import type { Theme } from 'src/app/providers/theme';
import styled from 'styled-components';

type DividerVariant = 'xs' | 'sm' | 'lg';

interface DividerProps {
  variant?: DividerVariant;
  fullWidth?: boolean;
}

const getMargin = (variant: DividerVariant, theme: Theme) => {
  switch (variant) {
    case 'xs':
      return theme.spacing(8);
    case 'sm':
      return theme.spacing(12);
    case 'lg':
      return theme.spacing(20);
    default:
      return theme.spacing(16);
  }
};

const StyledDivider = styled.hr<{ variant: DividerVariant; fullWidth?: boolean }>`
  border: 0;
  height: 2px;
  background-color: ${({ theme }) => theme.colors.blackSwan};
  width: 100%;
  margin: ${({ theme, variant }) => `${getMargin(variant, theme)} auto`};

  ${({ theme: { media }, fullWidth }) => media.medium(() => `width: ${fullWidth ? '100%' : '48.75rem'};`)};
`;

const Divider: React.FC<DividerProps> = ({ variant = 'sm', fullWidth = true }) => {
  return <StyledDivider variant={variant} fullWidth={fullWidth} />;
};

export default Divider;
